import { ChangeDetectorRef, Component } from '@angular/core';
import { EditorView } from 'prosemirror-view';

import { combineLatest, Observable, of, Subject } from 'rxjs';
import { startWith, switchMap, takeUntil } from 'rxjs/operators';

import { filterBoolean, trackByValue } from '@recruitee/common';
import { EditorButton } from '@recruitee/prosemirror';
import { IconColor } from '@recruitee/user-interface';

import { EditorView$, StateUpdated$ } from '../../consts';

@Component({
  selector: 'context-toolbar',
  templateUrl: './context-toolbar.component.html',
  styleUrls: ['./context-toolbar.component.less'],
  host: {
    '[class.context-alt]': 'true',
  },
})
export class ContextToolbarComponent {
  public readonly IconColor = IconColor;
  public buttons$: Observable<EditorButton[]>;

  public editorView: EditorView;
  public buttons: EditorButton[];
  public buttonsState: boolean[] = [];
  public trackByValue = trackByValue;

  private ngOnDestroy$ = new Subject();

  constructor(
    private stateUpdated$: StateUpdated$,
    private editorView$: EditorView$,
    private cdRef: ChangeDetectorRef,
  ) {}

  public ngOnInit() {
    this.editorView$
      .pipe(
        filterBoolean,
        switchMap(editorView =>
          combineLatest([this.buttons$, of(editorView), this.stateUpdated$.pipe(startWith(null))]),
        ),
      )
      .pipe(takeUntil(this.ngOnDestroy$))
      .subscribe(([buttons, editorView]) => {
        this.editorView = editorView;
        this.buttons = buttons;
        this.buttonsState = buttons.map(button => button.isActive(editorView.state));
        this.cdRef.detectChanges();
      });
  }

  public ngOnDestroy() {
    this.ngOnDestroy$.next();
    this.ngOnDestroy$.complete();
  }

  public onButtonClick(button: EditorButton, origin: HTMLElement) {
    const { state, dispatch } = this.editorView;
    button.run(state, dispatch, origin, true);
  }
}
